import { useQuery } from '@tanstack/react-query';
import type { UserAllowedCompany, UserAllowedCategory } from '@/types/userPermissions.types';
import { USER_PERMISSIONS_KEYS } from './userPermissions.queryKeys';
import { userPermissionsApi } from './userPermissions.api';

export const useGetAllowedCompaniesQuery = (userId: string) => {
    return useQuery<UserAllowedCompany[]>({
        queryKey: USER_PERMISSIONS_KEYS.allowedCompanies(userId),
        queryFn: () => userPermissionsApi.getAllowedCompanies(userId),
        enabled: !!userId,
    });
};

export const useGetAllowedCategoriesQuery = (userId: string) => {
    return useQuery<UserAllowedCategory[]>({
        queryKey: USER_PERMISSIONS_KEYS.allowedCategories(userId),
        queryFn: () => userPermissionsApi.getAllowedCategories(userId),
        enabled: !!userId,
    });
};
